import React from 'react';

import BillingError from '@components/BillingError';

const PAST_DUE_MESSAGE =
  'Your account is currently disabled. Re-join The Information on your existing plan by updating your payment method.';

const PastDueMessage = () => (
  <div id="resurrect-card">
    <div className="top">
      <h1 className="title">Re-Enable The Information</h1>
      <BillingError
        error={{ error_code: 'billing_past_due', message: PAST_DUE_MESSAGE }}
        className="title-sub"
      />
    </div>
  </div>
);

export default PastDueMessage;
